import { SpinnerService } from './../services/spinner.service';
import { AuthService } from './../services/auth.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

const APIWithoutSpinnerList: Array<string> = [
  "/api/SDI/UpdateSDIResult",
  "/api/SDI/SendXmlInvoicesToSDI",
  "/api/Notification/MarkAsRead",
  "/api/User/GetInvoiceInfoPackage",
  "/api/User/DashBoardInfo"
]

@Injectable()

/**
 * Intercetta le richieste http dall'applicazione per aggiungere un token di autenticazione JWT all'header
 * se l'utente ha effettuato l'accesso
 */
export class JwtInterceptor implements HttpInterceptor {

  constructor(
    private authenticationService: AuthService,
    private spinnerService: SpinnerService) { }

  /**
   * Se presente il token JWT concedo l'autorizzazione
   * @param request
   * @param next
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let currentToken = this.authenticationService.getCurrentToken();
    

    if (currentToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `${currentToken}`,
          'Access-Control-Allow-Origin': '*'
        }
      });
    }

    //Aggiunge la richiesta all'elenco delle richieste disponibili e mostra lo spinner
    if (!APIWithoutSpinnerList.find(x => request.url.includes(x) || request.url.includes('disableLoader=true')))
      this.spinnerService.addRequestCounter();

    //Invoca l'observable e resta in ascolto della conclusione della chiamata HTTP
    //per stoppare se necessario lo spinner
    return next.handle(request).pipe(
      tap(evt => {

        //Riaggiorna il token prendendolo dall'header della response.
        //Dato che il token viene gestito dal server, ogni chiamata autenticata restituirà nell'header della response il token con la data
        //di scadenza aggiornata.Con questa parte di codice ad ogni response ricevuta si va a sovrascrivere il token presente nel localStorage con quello aggiornato
        if (evt instanceof HttpResponse) {
          let updatedToken = evt.headers.get('Authorization');
          if (updatedToken)
            this.authenticationService.setCurrentToken(updatedToken);
        }
      }),
      finalize(() => this.removeRequest()));
  }

  /**
   * Rimuove la richiesta e mostra lo spinner
   */
  removeRequest() {
    this.spinnerService.removeRequestCounter();
  }
}
